import { render, staticRenderFns } from "./MostAssists.vue?vue&type=template&id=6199cce4&scoped=true&"
import script from "./MostAssists.vue?vue&type=script&lang=js&"
export * from "./MostAssists.vue?vue&type=script&lang=js&"
import style0 from "./MostAssists.vue?vue&type=style&index=0&id=6199cce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199cce4",
  null
  
)

export default component.exports